import { withCompInfo } from '@wix/editor-elements-integrations'
import type { BuilderDefinition } from '../Builder/Builder'
import { createBuilderProps } from '../Builder/Builder.mapper'
import { InternalContainerProps } from './InternalContainer'

export const props = withCompInfo<InternalContainerProps, BuilderDefinition>()(
	// @ts-ignore
	['innerElementsProps', 'compData', 'structure', 'reducedManifest', 'responsiveContainerProps', 'layers'],
	// @ts-ignore
	({ innerElementsProps, compData, structure, reducedManifest, layers, responsiveContainerProps }) => {
		const baseBuilderProps = createBuilderProps({
			innerElementsProps,
			compData,
			structure,
			reducedManifest,
		})

		return {
			...baseBuilderProps,
			layers,
			...responsiveContainerProps,
		}
	}
)
